export const TOGGLE_LOADING = 'auth/TOGGLE_LOADING'
export const SET_USER = 'auth/SET_USER'
export const SET_ERROR = 'auth/SET_ERROR'
export const TOGGLE_SUCCESS_VERIFIED = 'auth/TOGGLE_SUCCESS_VERIFIED'
export const SET_RESET_PASSWORD_ERROR = 'auth/SET_RESET_PASSWORD_ERROR'
export const SET_SUCCESSFUL_SENT_CODE = 'auth/SET_SUCCESSFUL_SENT_CODE'
